import CryptoJS from 'crypto-js'

var CryptographyAes = {

    /** 
     * @description Aes加密为Base64格式
     * @param {String} content 加密文本
     * @param {String} key 密钥
     * @returns Base64字符串
     */
    encryptToBase64: function (content, key) {
        let contentUtf8 = CryptoJS.enc.Utf8.parse(content);
        let keyUtf8 = CryptoJS.enc.Utf8.parse(key);
        let iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");
        let encrypted = CryptoJS.AES.encrypt(contentUtf8, keyUtf8, {
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },

    /** 
     * @description Base64字符串解密
     * @param {String} content base64密文
     * @param {String} key 密钥
     * @returns 明文
     */
    decryptFormBase64: function (content, key) {
        let keyUtf8 = CryptoJS.enc.Utf8.parse(key);
        let iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");
        let decrypted = CryptoJS.AES.decrypt(content, keyUtf8, {
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}

export default CryptographyAes;